import styles from "./input.module.css";

import {
  forwardRef,
  type HTMLAttributes,
  type InputHTMLAttributes,
  type LabelHTMLAttributes,
} from "react";

export interface InputErrorProps extends HTMLAttributes<HTMLSpanElement> {
  message?: string;
  showError: boolean;
}
export type InputProps = InputHTMLAttributes<HTMLInputElement>;
export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        className={`${styles.input} ${className}`}
        type={type}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, children, required, ...props }, ref) => {
    return (
      // biome-ignore lint/a11y/noLabelWithoutControl: Composable
      <label ref={ref} {...props} className={`${styles.label} ${className}`}>
        {children}
        {required && <span className={styles.required} />}
      </label>
    );
  }
);

Label.displayName = "Label";

const InputError = forwardRef<HTMLSpanElement, InputErrorProps>(
  ({ showError, message, className, ...props }, ref) => {
    return showError ? (
      <span ref={ref} {...props} className={`${styles.error} ${className}`}>
        {message}
      </span>
    ) : null;
  }
);

InputError.displayName = "Input Error";

export { Input, InputError, Label };
